import { Link } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EmailIcon from "@mui/icons-material/Email";
import PeopleIcon from "@mui/icons-material/People";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ContactsIcon from "@mui/icons-material/Contacts";
import CampaignIcon from "@mui/icons-material/Campaign";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AssessmentIcon from "@mui/icons-material/Assessment";
import RateReviewIcon from "@mui/icons-material/RateReview";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import BugReportIcon from "@mui/icons-material/BugReport";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import RadarIcon from "@mui/icons-material/Radar";
import SpeedIcon from "@mui/icons-material/Speed";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BusinessIcon from "@mui/icons-material/Business";
import TerminalIcon from "@mui/icons-material/Terminal";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import MapIcon from "@mui/icons-material/Map";
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupsIcon from "@mui/icons-material/Groups";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import HistoryIcon from "@mui/icons-material/History";
import TuneIcon from "@mui/icons-material/Tune";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HubIcon from "@mui/icons-material/Hub";
import ExtensionIcon from "@mui/icons-material/Extension";
import DescriptionIcon from "@mui/icons-material/Description";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import InsightsIcon from "@mui/icons-material/Insights";
import ScienceIcon from "@mui/icons-material/Science";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import PhoneIcon from "@mui/icons-material/Phone";

const CATALOG = [
  {
    category: "Analytics & Monitoring",
    color: "#4f46e5",
    bgColor: "#eef3ff",
    borderColor: "#c7d2fe",
    items: [
      {
        path: "/project-views",
        label: "Project Views",
        icon: ViewTimelineIcon,
        description:
          "Live views over Jira epics: every project, the step it is at, and its tickets.",
      },
      {
        path: "/dashboard",
        label: "Dashboard",
        icon: DashboardIcon,
        description: "Cost analytics, product overview, and session replays.",
      },
      {
        path: "/lead-conversion",
        label: "Lead Conversion",
        icon: TrendingUpIcon,
        description: "Track and analyze lead-to-customer conversion funnels.",
      },
      {
        path: "/qa-sprint-analytics",
        label: "QA Sprint Analytics",
        icon: BugReportIcon,
        description: "Quality assurance metrics and sprint bug tracking.",
      },
      {
        path: "/support-insights",
        label: "Support Insights",
        icon: SupportAgentIcon,
        description:
          "Trending support topics, AI-classified categories, and ticket drill-downs.",
      },
      {
        path: "/pc-watchdog",
        label: "PC Watchdog",
        icon: RadarIcon,
        description: "Monitor processing cluster health and job status.",
      },
      {
        path: "/pc-performance",
        label: "PC Performance",
        icon: SpeedIcon,
        description:
          "Processing checklist task and stage runtimes: avg, p90/p95, bottlenecks, and complexity notes.",
      },
      {
        path: "/langfuse-analytics",
        label: "AI Usage Analytics",
        icon: AnalyticsIcon,
        description: "LLM usage, costs, and trace analytics via Langfuse.",
      },
      {
        path: "/loan-stage-analytics",
        label: "Loan Stage Analytics",
        icon: TimelineIcon,
        description: "Export raw loan stage change events as a CSV file.",
      },
    ],
  },
  {
    category: "User & Organization Management",
    color: "#0891b2",
    bgColor: "#ecfeff",
    borderColor: "#a5f3fc",
    items: [
      {
        path: "/org-overview",
        label: "Org 360",
        icon: HubIcon,
        description:
          "One unified view per org: usage, billing, limits, AI cost, and more.",
      },
      {
        path: "/organization-loan-search",
        label: "Org Loan Search",
        icon: ManageSearchIcon,
        description: "Search and inspect loans across organizations.",
      },
      {
        path: "/user-permissions",
        label: "User / Org Permissions",
        icon: PeopleIcon,
        description: "Manage user roles and organization-level permissions.",
      },
      {
        path: "/loa-permissions",
        label: "LOA Permissions",
        icon: ManageAccountsIcon,
        description:
          "Per organization, take actions away from Loan Officer Assistants (they default to loan officer access) and set how many a Growth organization may have per paid seat.",
      },
      {
        path: "/enterprise-orgs",
        label: "Enterprise Orgs",
        icon: BusinessIcon,
        description: "View and configure enterprise organization accounts.",
      },
      {
        path: "/enterprise-billing-usage",
        label: "Enterprise Billing Usage",
        icon: AttachMoneyIcon,
        description:
          "Review per-loan billing usage and projected charges across enterprise orgs.",
      },
      {
        path: "/organization-limits",
        label: "Org Usage Limits",
        icon: TuneIcon,
        description:
          "Configure per-org AI quotas (OCR, PC auto-run) and toggle auto-run.",
      },
      {
        path: "/org-users-report",
        label: "Track Onboarding",
        icon: PeopleIcon,
        description: "Track user onboarding progress across organizations.",
      },
      {
        path: "/signups",
        label: "Sign-ups by Source",
        icon: HowToRegIcon,
        description:
          "People who signed up via a partner link (e.g. RadCRM): role, paying status, plan/amount, and PC runs.",
      },
      {
        path: "/org-usage-analytics",
        label: "User Usage",
        icon: GroupsIcon,
        description:
          "Organization adoption and per-user activity powered by LoanHistory.",
      },
      {
        path: "/client-tracking",
        label: "Client Tracking",
        icon: InsightsIcon,
        description:
          "Every client's accesses, users, manual runs and training instructions, with day-by-day and week-by-week evolution.",
      },
      {
        path: "/pilots",
        label: "Pilots",
        icon: ScienceIcon,
        description:
          "Running pilots from HubSpot with their owner, FDE and features, plus pilot-cost and client ROI calculators.",
      },
      {
        path: "/demo-invites",
        label: "Demo Invites",
        icon: VpnKeyIcon,
        description:
          "Private self-serve demo links for one prospect: one email, one device, an expiry date.",
      },
      {
        path: "/demo-access",
        label: "Demo Access",
        icon: VerifiedUserIcon,
        description:
          "Identity and competitor screening for demo invites: review applicants, AI web check results and the competitor registry.",
      },
      {
        path: "/referral-eligibility",
        label: "Referral Eligibility",
        icon: CardGiftcardIcon,
        description: "Manage which organizations can use the referral button.",
      },
    ],
  },
  {
    category: "Communication",
    color: "#7c3aed",
    bgColor: "#f5f3ff",
    borderColor: "#ddd6fe",
    items: [
      {
        path: "/marketing",
        label: "Marketing",
        icon: EmailIcon,
        description: "Send and manage marketing email campaigns.",
      },
      {
        path: "/announcements",
        label: "Announcements",
        icon: CampaignIcon,
        description: "Publish in-app announcements to users.",
      },
      {
        path: "/ask-addy-chats",
        label: "Ask Addy Chats",
        icon: ChatBubbleIcon,
        description: "Browse AI assistant conversations from users.",
      },
    ],
  },
  {
    category: "Operations",
    color: "#059669",
    bgColor: "#ecfdf5",
    borderColor: "#a7f3d0",
    items: [
      {
        path: "/feedback",
        label: "Feedback",
        icon: RateReviewIcon,
        description: "Review feedback submitted by users.",
      },
      {
        path: "/voice-console",
        label: "Voice Agent (test)",
        icon: PhoneIcon,
        description: "Try the voice agent on a dev loan: prompt, voice, call settings, live transcript.",
      },
      {
        path: "/changelogs",
        label: "Changelogs",
        icon: HistoryIcon,
        description: "Manage and publish product changelogs.",
      },
      {
        path: "/settings",
        label: "Whitelist Management",
        icon: SettingsIcon,
        description: "Manage whitelisted domains and access settings.",
      },
    ],
  },
  {
    category: "Integrations",
    color: "#db2777",
    bgColor: "#fdf2f8",
    borderColor: "#fbcfe8",
    items: [
      {
        path: "/integrations",
        label: "Integrations Hub",
        icon: ExtensionIcon,
        description: "Connect and manage LOS integrations.",
      },
      {
        path: "/newfi-split-edocs",
        label: "Split eDocs",
        icon: ContentCutIcon,
        description:
          "Newfi indexing packages in MeridianLink: every decision the pipeline made and every document it pushed back.",
      },
    ],
  },
  {
    category: "Dev Tools",
    color: "#b45309",
    bgColor: "#fffbeb",
    borderColor: "#fde68a",
    items: [
      {
        path: "/dev-tools",
        label: "Dev Tools",
        icon: TerminalIcon,
        description: "Internal developer utilities and debugging tools.",
      },
      {
        path: "/prompts",
        label: "Prompts",
        icon: DescriptionIcon,
        description:
          "View and edit LLM prompts and processing checklist task instructions synced from the repo.",
      },
      {
        path: "/prod-deployment",
        label: "Prod Deployment",
        icon: RocketLaunchIcon,
        description: "Manage and trigger production deployments.",
      },
      {
        path: "/roadmap",
        label: "Roadmap",
        icon: MapIcon,
        description: "View and manage the product roadmap.",
      },
      {
        path: "/evals",
        label: "Evals",
        icon: TimelineIcon,
        description: "Run and review AI model evaluation results.",
      },
      {
        path: "/model-switch-eval",
        label: "Evals",
        icon: CompareArrowsIcon,
        description:
          "Compare baseline vs candidate model drift across the golden corpus before switching.",
      },
      {
        path: "/gcp-monitoring",
        label: "GCP Monitoring",
        icon: MonitorHeartIcon,
        description:
          "Live Cloud Run memory, Cloud Tasks queues, errors, and document root causes with a ranked diagnosis.",
      },
      {
        path: "/notifications",
        label: "Notification Traces",
        icon: NotificationsIcon,
        description: "Inspect notification traces and delivery logs.",
      },
      {
        path: "/queue",
        label: "Queue",
        icon: FormatListBulletedIcon,
        description: "View and manage the document processing queue.",
      },
    ],
  },
  {
    category: "Legacy",
    color: "#6b7280",
    bgColor: "#f9fafb",
    borderColor: "#e5e7eb",
    items: [
      {
        path: "/processing-monitoring",
        label: "Processing Monitoring",
        icon: AssessmentIcon,
        description: "Monitor document processing jobs and pipeline health.",
      },
      {
        path: "/contacts",
        label: "Contacts",
        icon: ContactsIcon,
        description: "Browse and manage contact records.",
      },
    ],
  },
];

const CatalogItem = ({ path, label, icon: Icon, description, color }) => (
  <Link
    to={path}
    style={{ textDecoration: "none", color: "inherit" }}
  >
    <div
      className="d-flex align-items-start gap-3 p-3 rounded-3 h-100"
      style={{
        border: "1px solid #e5e7eb",
        backgroundColor: "#fff",
        transition: "box-shadow 0.15s ease, border-color 0.15s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
        e.currentTarget.style.borderColor = color;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.borderColor = "#e5e7eb";
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
        style={{
          width: 40,
          height: 40,
          backgroundColor: color + "18",
          color,
        }}
      >
        <Icon style={{ fontSize: 22 }} />
      </div>
      <div>
        <div className="fw-semibold mb-1" style={{ fontSize: "0.95rem", color: "#111827" }}>
          {label}
        </div>
        <div style={{ fontSize: "0.82rem", color: "#6b7280", lineHeight: 1.4 }}>
          {description}
        </div>
      </div>
    </div>
  </Link>
);

const HomeCatalogPage = () => (
  <div
    className="container-fluid"
    style={{ paddingTop: 28, paddingBottom: 40, maxWidth: 1100 }}
  >
    <div className="mb-4">
      <h1 className="mb-1" style={{ fontSize: "1.6rem", fontWeight: 700, color: "#111827" }}>
        Admin Dashboard
      </h1>
      <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>
        All internal tools in one place. Select a section to get started.
      </p>
    </div>

    <div className="d-flex flex-column gap-4">
      {CATALOG.map((section) => (
        <div key={section.category}>
          <div
            className="d-flex align-items-center gap-2 mb-3 px-3 py-2 rounded-2"
            style={{
              backgroundColor: section.bgColor,
              border: `1px solid ${section.borderColor}`,
              display: "inline-flex",
            }}
          >
            <span
              className="fw-semibold"
              style={{ fontSize: "0.85rem", color: section.color, letterSpacing: "0.02em" }}
            >
              {section.category.toUpperCase()}
            </span>
          </div>

          <div className="row g-3">
            {section.items.map((item) => (
              <div key={item.path} className="col-12 col-sm-6 col-lg-4">
                <CatalogItem {...item} color={section.color} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default HomeCatalogPage;
